import React from 'react';
import './NegativeAuraBorderEffect.css';

function prefersReducedMotion() {
  if (typeof window === 'undefined' || !window.matchMedia) {
    return false;
  }
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

/**
 * Pulsing purple border around negative aura providers on the battlefield.
 * Rings grow outward, dissipate, and recreate in a staggered loop.
 */
export function NegativeAuraBorderEffect({ className = '' }) {
  const reducedMotion = prefersReducedMotion();

  return (
    <div
      className={[
        'negative-aura-border',
        reducedMotion ? 'negative-aura-border--static' : '',
        className,
      ]
        .filter(Boolean)
        .join(' ')}
      aria-hidden="true"
    >
      <div className="negative-aura-border__ring negative-aura-border__ring--a" />
      <div className="negative-aura-border__ring negative-aura-border__ring--b" />
      <div className="negative-aura-border__ring negative-aura-border__ring--c" />
    </div>
  );
}

export default NegativeAuraBorderEffect;
